<template>
  <div class="pt20">
	  <div class="design_box_out">
		  <div class="swiper-container">
		  	 <div class="couponsBox swiper-wrapper" style="transform: translate3d(0px, 0px, 0px);">
		  		 <div class="swiper-slide" style="width: 205px;" v-for="(item,index) in list">
		  			 <div class="couponsBox1 ">
		  				<p class="prices">¥<span>{{item.reduction}}</span></p>
		  				<p class="marginLeft30">全店满{{item.full}}元可用</p>
		  			 </div>
		  		 </div>
		  	 </div>
		  </div>
	  </div>
    <!-- <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p>
      <div class="team-desc design_box">
        <div class="team-desc-body">
          <div class="team-desc-list" v-for="(item,index) in property.list" :key="index">
            <div class="team-desc-list-body">
              <div class="team-desc-list-img"
                   :style="{backgroundImage:'url('+item.pic+')',backgroundSize:'cover',backgroundPosition:'center'}">
              </div>
              <p class="team-desc-list-name">{{item.name?item.name:'姓名'}} <span>{{item.position?item.position:'职位'}}</span></p>
              <p class="team-desc-list-company">公司总经理</p>
              <p class="team-desc-list-desc">{{item.info?item.info:'简介'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
	import Swiper from "swiper";
  export default {
    props: ["property"],
    data() {
      return {
        defultImg: '/static/img/userDefult.png',
		list:[],
        form: {}
      };
    },
	mounted() {
		new Swiper('.swiper-container', {
			// loop: false,
		 //    pagination: '.swiper-pagination',
			// nextButton: 'swiper-button-next',
			// prevButton: 'swiper-button-prev',
			// scrollbar: 'swiper-scrollbar',
		    slidesPerView: 2,
		    centeredSlides: true,
		    // paginationClickable: true,
		    // spaceBetween: 30,
		    // grabCursor: true
		});
	},
    created() {
		console.log(this.property,"this.property80==========")
		this.list = this.property.list
    }
  };
</script>

<style>
	@import '../../assets/css/swiper.min.css';
	.couponsBox{width: 100%;height: 80px;display: flex;}
	.couponsBox1{width: 100%;height: 100%;background-image: url("../../assets/imgs/marshalling7.png");background-size: 100% 100%;}
	.couponsBox2{width: 40%;height: 100%;background-image: url("../../assets/imgs/marshalling8.png");background-size: 100% 100%;}
	.couponsBox1 >p{height: 20px;color: #FFEDBD;line-height: 20px;font-weight: 400;
	/* margin-left: 47px; */
	padding-top: 15px;}
	.prices{margin-left: 47px;font-size: 14px;}
	.marginLeft30{margin-left: 29px;margin-top: 10px;font-size: 12px;}
	.couponsBox1 >p >span{font-size: 32px;}
	.swiper-container{width: 436px;height: 80px;margin: 20px auto;}
</style>

